export const ExclusiveEmptyCard = () => {
  return (
    <div className="overflow-hidden relative h-[var(--card-height)] rounded content-center border border-grayA-2 bg-white/[1%]">
      <h2 className="text-center">No Exclusives unlocked yet</h2>
    </div>
  )
}
